import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '../grid';

const SectionHeaderContainer = styled.div`
  padding-top: 49px;
  padding-bottom: 50px;
  text-align: center;
  line-height: 38px;
`;

const SectionHeaderInner = styled.div`
  max-width: 1050px;
  padding: 0 25px;
  margin: 0 auto;
`;

const Desc = styled.p`
    color: #666666;
    max-width: 480px;
    margin: 0 auto;
    font-size: 18px;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: 0.54px;
`



function TcnhScenarios({ input }) {
    const { primary, items } = input;
    return (
        <SectionHeaderContainer>
            <SectionHeaderInner>
                <Grid columns={6} justifyContent="center">
                  {items.map((item, i) => {
                    return (
                      <Cell key={i} xs={3} sm={2}>
                        <a href={item.link.url} target="_blank" rel="noopener noreferrer" styled="padding:1px 1px 1px 1px;" >
                          <img src={item.image.url} />
                        </a>
                      </Cell>
                    );
                  })}
                </Grid>
                <Desc>{ primary.desc.text }</Desc>
            </SectionHeaderInner>
        </SectionHeaderContainer>
    );
}

export { TcnhScenarios };
